import axios from "axios";
const basePath = process.env.VUE_APP_HZMB_GH_BASE_PATH;

/**
 * 准入
 * @param {*} serviceType
 * @param {*} approveNo
 * @param {*} registrationNo
 * @param {*} identificationNo
 * @param {*} identType
 * @param {*} identNo
 * @returns
 */
const check = (
  registrationNo,
  identificationNo,
  approveNo,
  identType,
  identNo,
) => {
  return axios
    .post(
      `${basePath}/protected/api/v1/application/hzmbG/insurance/check`,
      null,
      {
        params: {
          approveNo,
          registrationNo,
          identificationNo,
          identType,
          identNo,
        },
      }
    )
    .then((res) => res.data);
};

/**
 * 查詢詳情
 * @param {*} applicationId
 * @returns
 */
const getById = (applicationId) => {
  return axios
    .get(
      `${basePath}/protected/api/v1/application/hzmbG/insurance/${applicationId}`
    )
    .then((res) => res.data);
};

/**
 * 暫存
 * @param {*} form
 * @returns
 */
const tempSave = (form) => {
  return axios
    .post(
      `${basePath}/protected/api/v1/application/hzmbG/insurance/temp-save`,
      form
    )
    .then((res) => res.data);
};

/**
 * 暫存申請文件
 * @param {*} applicationId
 * @param {*} file
 * @param {*} fileValue
 * @returns
 */
const saveFile = (applicationId, file, fileValue) => {
  let formData = new FormData();
  formData.append("file", file);
  formData.append(
    "fileValue",
    new Blob([JSON.stringify(fileValue)], {
      type: "application/json",
    })
  );
  return axios
    .post(
      `${basePath}/protected/api/v1/application/hzmbG/insurance/upload/${applicationId}`,
      formData
    )
    .then((res) => res.data);
};

/**
 * 刪除文件
 * @param {*} applicationId
 * @param {*} id
 * @returns
 */
const delFile = (applicationId, id) => {
  return axios
    .delete(
      `${basePath}/protected/api/v1/application/hzmbG/insurance/delete/file/${applicationId}/${id}`
    )
    .then((res) => res.data);
};

/**
 * 下載文件
 * @param {*} applicationId
 * @param {*} id
 * @returns
 */
const downloadFile = (applicationId, id) => {
  return axios
    .get(
      `${basePath}/protected/api/v1/application/hzmbG/insurance/download/file/${applicationId}/${id}`,
      {
        responseType: "blob",
      }
    )
    .then((res) => res);
};

/**
 * 提交
 * @param {*} id
 * @returns
 */
const submit = async (applicationId) => {
  let { data } = await axios({
    method: "post",
    url: `${basePath}/protected/api/v1/application/hzmbG/insurance/submit`,
    params: {
      id: applicationId,
    },
  });

  return data;
};

export default {
  check,
  getById,
  tempSave,
  saveFile,
  delFile,
  downloadFile,
  submit,
};
